 /*
创建者 魏强(2018.3.8)
自营商城 菜单对应的模块
*/
<template>
    <div class="mod-selling green" :id="'gd-selling-'+ num" >
    	<div v-for="(cato,catIndex) in cat" v-if="cato.index_page_category_id == num" :key="catIndex">
    			<h3 class="mod-selling-title">
    				<span>{{cato.content}}</span>
    			</h3>
    			<div class="mod-common">
    				<!-- 菜单 -->
		            <div class="col-menu">
		            	<strong>最热HOT</strong>
		            		<router-link v-for="cato1 in cato.childrean" :to="cato1.to" target="_blank" :key="cato1.key">
		            			{{cato1.content}}
		            		</router-link>
		            </div>
		            <!-- 广告 -->
		            <div class="col-img">
						<router-link v-for="(item,index) in adv" :to="item.to" target="_blank" v-if="index==0" :key="index">
							<img :src="item.atturl" :alt="item.aname" height="474px" width="192px" />
						</router-link>
		            </div>
		            <!-- 商品 -->
					<div class="col-goods">
		            	<ul class="clearfix">
				            	<li class="double" v-for="(item,index) in goods1" v-if="index==0" :key="item.key+100">
									<router-link  :to="item.to" target="_blank" class="col-goods-item">
										<img :src="item.atturl" :alt="item.aname"  height="236px" width="395px" />
									</router-link>
								</li>
		            			<li v-for="(item,index) in goods2"  v-if="index<5" :key="item.key">
    								<router-link  :to="item.to" target="_blank"  class="col-goods-item">
										<img :src="item.atturl" :alt="item.aname"  height="236px" width="197px" />
									</router-link>
    							</li>
		                </ul>
		            </div>
					<!-- 轮播 -->
		            <div class="col-swipe">
					    <div class="col-swipe-image" :key="1">
					        <div class="swipe-wrap">
					            <div class="swipe" id="colswiper-image1">
					                <Carousel
							            v-model="value1"
							            :autoplay="setting.autoplay"
							            :autoplay-speed="setting.autoplaySpeed"
							            :dots="setting.dots"
							            :radius-dot="setting.radiusDot"
							            :trigger="setting.trigger"
							            :arrow="setting.arrow"
							        >
							            <CarouselItem v-for="item in banners1" :key="item.key" >
							                <div>
							                    <router-link :to="item.to" target="_blank">
							                        <img :src="item.atturl" :alt="item.aname"   class="scrollLoading">
							                    </router-link>
							                </div>
							            </CarouselItem>
							        </Carousel>
					            </div>
					        </div>
					    </div>
					    <div class="col-swipe-goods" :key="2">
					        <div class="swipe-wrap">
					            <div class="swipe" id="colswiper-goods1">
					                <Carousel
							            v-model="value2"
							            :autoplay="setting.autoplay"
							            :autoplay-speed="setting.autoplaySpeed"
							            :dots="setting.dots"
							            :radius-dot="setting.radiusDot"
							            :trigger="setting.trigger"
							            :arrow="setting.arrow"
							        >
							            <CarouselItem v-for="(item,index) in banners2" :key="item.key" >
							                <div>
							                    <router-link v-for="item2 in item.children" :to="item2.to" target="_blank" :key="item2.aid">
							                        <img :src="item2.atturl" :alt="item2.aname" width="143px" height="143px" />
							                    </router-link>
							                </div>
							            </CarouselItem>
							        </Carousel>
					            </div>
					        </div>
					    </div>
					</div>
		        </div>
    	</div>
    </div>
</template>
<script>
export default {
	props:["data","cat","other"],
	data() {
		let  {adv,goods1,goods2,banners1,banners2} = this.data;
		let {num} = this.other;
		let temp = [];
		for(let i=0,len=banners2.length;i<len;i++){
			let index = parseInt(i/2);
			temp[index] = temp[index] || {};
			temp[index].key=index;
			temp[index].children=temp[index].children||[];
			temp[index].children.push( banners2[i] )
		}
		banners2 = temp;
	    return {
	        adv,goods1,goods2,banners1,
	        banners2,
	        value1:0,
	        value2:0,
	        num,//id 编号
            setting: {
                autoplay: true,
                autoplaySpeed: 5000,
                dots: 'inside',
                radiusDot: true,
                trigger: 'hover',
                arrow:"never"
            }
	    }
	}
}
</script>



// WEBPACK FOOTER //
// gd-selling-item.vue?511de2d6